import dayjs from 'dayjs';
import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import {fetchSignedUrl, uploadDocumentToS3} from "../services/aws.service";
import {timezones} from './timezones'

export const isJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export const dayNames = [
  'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun',
]

export const isValidName = (name) => {
  return /^[a-zA-Z]/.test(name); // Check first character is alphabet not number
}

export const formatCurrency = (value, currency="USD") => {
  let USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency || 'USD',
  });
  return USDollar.format(value ?? 0)
}

export const getAddress = (location) => {
  const addressArray = [location?.addressLine1, location?.addressLine2, location?.city, location?.state, location?.country];
  return addressArray.filter((value) => !!value).join(", ")
}

export const displayAddess = (city, state, country) => {
  const addressArray = [city, state, country];
  return addressArray.filter((value) => !!value).join(", ")
}

export const uploadToS3 = async (file, type, id) => {
  try {
    const payload = {
      s3Input: {
        contentType: file.type,
        fileName: `${type}.${file.name?.split('.').pop()}`,
        uploadType: type,
        uuid: id,
      },
    }
    const response = await fetchSignedUrl(payload)
    const {sUrl, pUrl} = response.data.signedUrl
    if (sUrl) {
      await uploadDocumentToS3(sUrl, file, file.type)
      return pUrl
    }
  } catch (error) {
    console.error(error)
  }
  return ""
}

export const getPhoneNumber = (phoneCode, phone) => {
  return `${phoneCode ? `+${phoneCode}` : ''} ${phone ? ` ${phone?.slice(phoneCode?.length, phone?.length)}` : 'Not available'}`
}

export const formatDate = (date, format) => {
  return dayjs(date).format(format || 'DD-MMM-YYYY')
}

export const getYearList = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const yearList = [];
  for (var i = currentYear; i >= 1950; i--) {
    const year = {
      label: i,
      value: i
    }
    yearList.push(year);
  }
  return yearList;
}

export const sortSkills = (firstSkill, secondSkill) => {
  // First level sorting should be based on year selected on skills
  // Second level sorting should be based on Alphabets
  // Primary skill should be always in first and above 2 rules must apply within Primary skills.

  if (!!firstSkill?.isPrimary && !secondSkill?.isPrimary) {
    return -1;
  } else if (!firstSkill?.isPrimary && !!secondSkill?.isPrimary) {
    return 1;
  }

  if (firstSkill?.experience !== secondSkill?.experience) {
    return secondSkill?.experience - firstSkill?.experience;
  }

  return firstSkill.name.localeCompare(secondSkill.name);
}

export const timeZoneList = timezones;

export const isValidMonthlyRate = (rate) => {
  return /^\d{0,5}$/.test(rate);
}

export const capitalizeError = (field) => {
  if (field) {
    const result = field.replace(/([A-Z])/g, ' $1');
    return `${result[0].toUpperCase() + result.substring(1).toLowerCase()} is required`;
  }
  return '';
}

export const handleSkillSearch = (props, option, state) => {
  {
    if (!state?.inputValue && !!option?.alias) {
      return null
    }
    if (state?.inputValue && !!option?.alias) {
      return <li {...props}>{option.name} {`(alias)`}</li>
    }
    return <li {...props}>{option.name}</li>
  }
}